"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 6
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#919499",
    fillRule: "evenodd",
    d: "M.625 5.486L0 4.705 5.881 0l5.748 4.709-.632.773-5.123-4.195z"
  }));
}

var MemoSvgArrowDown = /*#__PURE__*/React.memo(SvgArrowDown);
var _default = MemoSvgArrowDown;
exports["default"] = _default;